import type { InventoryRow } from "./hub-operation-types.js";

export type InventoryColumnId =
	| "astId"
	| "status"
	| "category"
	| "description"
	| "brand"
	| "model"
	| "serialNumber"
	| "purchaseDate"
	| "purchasePrice"
	| "ourWarrantyExpiry"
	| "supplierWarrantyExpiry"
	| "vendorId"
	| "custody";

export const INVENTORY_TABLE_COLUMNS: Array<{ id: InventoryColumnId; label: string; sortable?: boolean }> = [
	{ id: "astId", label: "ID", sortable: true },
	{ id: "category", label: "Category", sortable: true },
	{ id: "description", label: "Description", sortable: true },
	{ id: "brand", label: "Brand", sortable: true },
	{ id: "model", label: "Model", sortable: true },
	{ id: "serialNumber", label: "Serial number", sortable: true },
	{ id: "custody", label: "Custody", sortable: false },
	{ id: "status", label: "Status", sortable: true },
	{ id: "purchaseDate", label: "Purchase date", sortable: true },
	{ id: "purchasePrice", label: "Purchase price", sortable: true },
	{ id: "ourWarrantyExpiry", label: "Our warranty expiry", sortable: true },
	{ id: "supplierWarrantyExpiry", label: "Supplier warranty expiry", sortable: true },
	{ id: "vendorId", label: "Vendor", sortable: false },
];

export const INVENTORY_COLUMN_IDS = INVENTORY_TABLE_COLUMNS.map((column) => column.id);

export function defaultInventoryColumnVisibility(): Record<InventoryColumnId, boolean> {
	return Object.fromEntries(INVENTORY_TABLE_COLUMNS.map((column) => [column.id, true])) as Record<InventoryColumnId, boolean>;
}

export function mergeInventoryColumnVisibility(stored: Record<string, boolean> | undefined): Record<InventoryColumnId, boolean> {
	const base = defaultInventoryColumnVisibility();
	if (!stored) return base;
	if (typeof stored.location === "boolean" && typeof stored.custody !== "boolean") {
		base.custody = stored.location;
	}
	for (const column of INVENTORY_TABLE_COLUMNS) {
		if (typeof stored[column.id] === "boolean") base[column.id] = stored[column.id]!;
	}
	if (!Object.values(base).some(Boolean)) base.astId = true;
	return base;
}

export function inventoryRowMatchesSearch(row: InventoryRow, query: string, vendorName: string): boolean {
	const q = query.trim().toLowerCase();
	if (!q) return true;
	return [
		row.astId,
		row.description,
		row.model,
		row.serialNumber,
		row.it,
		row.brand,
		row.category,
		vendorName,
	].some((part) => part.toLowerCase().includes(q));
}
